import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { isDayWithinScheduleRule } from '@shared-helpers/date-helpers';

import { ISelectOptions } from '../../../interfaces/internal-interfaces';
import { ITimesheetDate } from '../../../scripts/timesheetHandler';

@Component({
  selector: 'app-modal-content-nonbillable-select',
  templateUrl: './modal-content-nonbillable-select.component.html',
  styleUrl: './modal-content-nonbillable-select.component.css',
  standalone: false,
})
export class ModalContentNonbillableSelectComponent implements OnInit {
  @Input() public attendance: ISelectOptions[] = [];
  @Input() public absence: ISelectOptions[] = [];
  @Input() public workScheduleRule: string;
  @Input() public focusedDay: ITimesheetDate | undefined;

  @Output() public readonly closed = new EventEmitter<ISelectOptions>();

  public shouldShowAbsences = true;

  public ngOnInit(): void {
    //When performing a "horizontal bulk add" for a user, the focusedDay will not be available since this will apply to more than 1 day
    if (this.focusedDay) {
      this.shouldShowAbsences = isDayWithinScheduleRule(this.workScheduleRule, this.focusedDay.weekDay);
    }
  }

  public select(element: ISelectOptions): void {
    this.closed.emit(element);
  }
}
